import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/api";

const inputCls =
  "w-full rounded-lg border-2 border-[#F5F2EB] bg-[#141414] px-4 py-3 text-sm font-mono text-[#F5F2EB] placeholder-[#F5F2EB]/40 transition-shadow focus:shadow-[3px_3px_0_#F5F2EB] focus:outline-none";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("jfly_token", data.token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center px-6">
      <div className="w-full max-w-sm rounded-2xl border-2 border-[#F5F2EB] bg-[#141414] p-8 shadow-[8px_8px_0_#F5F2EB] md:p-10">
        <Link
          to="/"
          data-testid="admin-login-back-link"
          className="text-[10px] font-mono font-medium uppercase tracking-[0.3em] text-[#F5F2EB]/50 transition-colors hover:text-[#FF3B1F]"
        >
          ← JFLY
        </Link>
        <h1 className="mt-6 font-serif text-3xl font-black uppercase tracking-tight">Admin</h1>
        <p className="mt-1 text-xs font-mono text-[#F5F2EB]/50">Sign in to manage the rack</p>

        <form onSubmit={submit} data-testid="admin-login-form" className="mt-8 space-y-4">
          <input
            required
            type="email"
            data-testid="admin-email-input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
          />
          <input
            required
            type="password"
            data-testid="admin-password-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
          />
          {error && (
            <p data-testid="admin-login-error" className="rounded-lg border-2 border-[#FF3B1F] bg-[#FF3B1F]/10 px-3 py-2 text-xs font-mono text-[#FF3B1F]">
              {error}
            </p>
          )}
          <button
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full rounded-full border-2 border-[#F5F2EB] bg-[#FF3B1F] px-6 py-3 text-xs font-mono font-medium uppercase tracking-[0.2em] text-white shadow-[4px_4px_0_#F5F2EB] transition-transform hover:-translate-y-0.5 disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
